export default __webpack_public_path__ + "static/trends-breakdown-dark-mode-3588959bcce108f96bb5759f9de6a9a8.png";